import { createSelector } from 'reselect';
import pick from 'lodash/pick';
import { deliverySelector } from 'redux/modules/delivery/selectors';

export const lastDeliverySettingsSelector = createSelector(
  deliverySelector,
  delivery => pick(delivery, ['lastDeliveryTimeType', 'lastScheduleTime']),
);
